import SettingsSvg from '../assets/settings.svg';

export function SettingsIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={SettingsSvg} alt='Settings' />;
}
